import {
  CreateAreaPayload,
  CreateAreaReworkPayload,
  ReworkAreasResponse,
  RouteAreaViewListItemResponse
} from "../types/areas";
import api from "./index";
import qs from "qs";

export const createArea = async (request: CreateAreaReworkPayload): Promise<CreateAreaReworkPayload> => {
    const response = await api.post(`/v1/route-areas/`, request);
    return response.data;
}

export const getRouteAreas = async (routeId: string): Promise<CreateAreaPayload[]> => {
    const response = await api.get(`/v1/route-areas/route/${routeId}`);
    return response.data;
}

export const deleteRouteArea = async (id: number): Promise<void> => {
    await api.delete(`/v1/route-areas/${id}`);
}

export const createAreaRework = async (
  payload: CreateAreaReworkPayload
): Promise<CreateAreaReworkPayload[]> => {
  const response = await api.post("/v1/area-types/route-area", payload);
  return response.data;
};

export const getAreaReworkById = async (
  id: string
): Promise<CreateAreaReworkPayload> => {
  const response = await api.get(
    `/v1/area-types/view/${id}`
  );
  return response.data;
}

export const updateAreaRework = async (
  id: number | undefined,
  payload: CreateAreaReworkPayload
): Promise<CreateAreaReworkPayload> => {
  const response = await api.put(`/v1/area-types/view/${id}`, payload);
  return response.data;
};

export const getAllAreas = async (
  search = "",
  page = 1,
  size = 30,
  sort = "name,asc",
  routeId?: string,
  selectedAreaIds?: (string | number)[]
): Promise<ReworkAreasResponse> => {
  const response = await api.get<ReworkAreasResponse>(`/v1/area-types/view`, {
    params: {
      search,
      ...(page >= 0 ? { page } : {}),
      size,
      sort,
      routeId,
      ...(selectedAreaIds && selectedAreaIds.length > 0 ? { selectedAreaIds } : {}),
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
  return response.data;
};

export const deleteAreById = async (id: string): Promise<void> => {
  await api.delete(`/v1/area-types/route-area/${id}`);
};

export const getAllGlobalAreas = async (): Promise<RouteAreaViewListItemResponse[]> => {
  const response = await api.get<RouteAreaViewListItemResponse[]>("/v1/area-types/global");
  return response.data;
};

export const saveAreasRoute = async (routeId: string, payload: {areasId: number[]}): Promise<boolean> => {
  const response = await api.put<any>(`v1/area-types/link/route/${routeId}`, payload);
  return response.data;
};
